import { defineComponent, openBlock, createBlock, unref, withCtx, createElementVNode, toDisplayString } from "vue";
import { CdrButton, IconHeartFill, IconHeartStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxFavoriteButton",
  props: {
    dataCnstrcBtn: {
      default: null
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(CdrButton), {
        "icon-only": "",
        "with-background": "",
        class: "favorite-button",
        "data-cnstrc-btn": _ctx.dataCnstrcBtn
      }, {
        icon: withCtx(() => [_ctx.isFavorite ? (openBlock(), createBlock(unref(IconHeartFill), {
          key: 0,
          class: "favorite-button__heart favorite-button__heart--is-favorite"
        })) : (openBlock(), createBlock(unref(IconHeartStroke), {
          key: 1,
          class: "favorite-button__heart"
        }))]),
        default: withCtx(() => [createElementVNode("span", _hoisted_1, toDisplayString(_ctx.isFavorite ? "item is in wishlist" : "add item to wishlist"), 1)]),
        _: 1
      }, 8, ["data-cnstrc-btn"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxFavoriteButton2.mjs.map
